import React from 'react';
import { useNavigate } from 'react-router-dom';

const useStepNavigator = (steps: { path: string; screen: Function }[], index: number, skipSteps: number[]) => {
    const navigate = useNavigate();

    const nextStepIndex = () => {
        let nextIndex = index + 1;
        while(skipSteps.indexOf(nextIndex) != -1){
            nextIndex = nextIndex + 1;
        }
        return nextIndex;
    }

    const previousStepIndex = () => {
        let nextIndex = index - 1;
        while(skipSteps.indexOf(nextIndex) != -1){
            nextIndex = nextIndex - 1;
        }
        return nextIndex;
    }

    const currentStep = steps[index];
    const previousStep = steps[previousStepIndex()];
    const nextStep = steps[nextStepIndex()];

    const goForward = (): void => nextStep && navigate(nextStep.path);
    const goBack = (): void => previousStep && navigate(previousStep.path);

    return [currentStep, { goForward, goBack }];
};

export default useStepNavigator;
